/**
 * Web router.
 *
 * Layout structure:
 *   - "/login"  → AuthLayout → LoginPage  (Telegram OTP flow)
 *   - "/"       → MainLayout → HomeScreen (auth-gated, full habits/goals/life/pomodoro tabs)
 *   - "*"       → redirect to "/"
 *
 * The HomeScreen + every nested feature page were copied from the
 * Telegram-app in WebApp Phase 11; they consume @turnifly/shared
 * for all data + state, and use the haptic adapter so the same code
 * runs in browser, PWA, and Capacitor without Telegram SDK.
 */

import { createBrowserRouter, Navigate } from 'react-router-dom'
import { App } from '../App'
import { AuthLayout } from './layouts/auth-layout'
import { MainLayout } from './layouts/main-layout'
import { LoginPage } from '../features/auth/login-page'
import { HomeScreen } from '../features/home/components/home-screen'
import { FeedScreen } from '../features/feed/components/feed-screen'
import { ProfileScreen } from '../features/profile/components/profile-screen'
import { PaymentResultPage } from '../features/profile/components/payment-result-page'
import { InboxScreen } from '../features/inbox/components/inbox-screen'
import { InboxChatScreen } from '../features/inbox/components/inbox-chat-screen'
import { ChallengesScreen } from '../features/challenges/components/challenges-screen'
import { ChallengeProfileScreen } from '../features/challenges/components/challenge-profile-screen'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <MainLayout />,
        children: [
          { index: true, element: <HomeScreen /> },
          { path: 'feed', element: <FeedScreen /> },
          { path: 'profile', element: <ProfileScreen /> },
          { path: 'profile/:id', element: <ProfileScreen /> },
          { path: 'payment-result', element: <PaymentResultPage /> },
          { path: 'inbox', element: <InboxScreen /> },
          { path: 'inbox/chat/:conversationId', element: <InboxChatScreen /> },
          { path: 'challenges', element: <ChallengesScreen /> },
          { path: 'challenges/:id', element: <ChallengeProfileScreen /> },
        ],
      },
      {
        path: '/login',
        element: <AuthLayout />,
        children: [
          { index: true, element: <LoginPage /> },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
])
